import React from 'react';
import PropTypes from 'prop-types';
import { Row, Column } from 'hedron';
import FilterTitle from '../../FilterTitle';

const RefineTitle = ({
  fontSize, bold, padding, title, isDesktop
}) => (
  <Row style={{ padding }}>
    <Column fluid>
      <FilterTitle data-cy={`refine-title-${title}`} bold={bold} fontSize={fontSize} padding={isDesktop ? 0 : 5}>
        {title}
      </FilterTitle>
    </Column>
  </Row>
);

RefineTitle.propTypes = {
  bold: PropTypes.bool,
  fontSize: PropTypes.number,
  isDesktop: PropTypes.bool,
  padding: PropTypes.string,
  title: PropTypes.string
};

export default RefineTitle;
